function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeusToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "#1A1A21",
    style: {
      fill: "#1A1A21",
      fill: "color(display-p3 0.1020 0.1020 0.1295)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56701 6.125L3.75 9.27257H6.96973L5.51625 14.1447L13.1919 9.27257H10.0848L10.934 6.125H4.56701Z",
    fill: "url(#paint0_linear_2_4493)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.191 9.27063H15.75L5.51433 14.1427L13.191 9.27063Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4493",
    x1: 8.47091,
    y1: 6.125,
    x2: 8.47091,
    y2: 12.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB83",
    style: {
      stopColor: "#FFEB83",
      stopColor: "color(display-p3 1.0000 0.9216 0.5137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247213,
    stopColor: "#FFBF83",
    style: {
      stopColor: "#FFBF83",
      stopColor: "color(display-p3 1.0000 0.7490 0.5137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682213,
    stopColor: "#E677E9",
    style: {
      stopColor: "#E677E9",
      stopColor: "color(display-p3 0.9031 0.4685 0.9120)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B283FF",
    style: {
      stopColor: "#B283FF",
      stopColor: "color(display-p3 0.6985 0.5137 1.0000)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeusToken);
export default __webpack_public_path__ + "static/media/zeus-token.6d04a2d762b1252b1bdacda6aee21ea7.svg";
export { ForwardRef as ReactComponent };